import * as React from 'react';

import NoEntities from '../../../../shared/NoEntities';

const NoPaymentMethods: React.FunctionComponent = () => {
  return <NoEntities>お支払い方法はありません</NoEntities>;
};

export default React.memo(NoPaymentMethods);
